import { Reveal } from "@/components/Reveal";

export const About = () => {
  return (
    <section
      className="py-32 md:py-44 overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-14 md:gap-20 items-center">
        <Reveal className="md:col-span-5 md:-translate-y-6">
          <div className="overflow-hidden">
            <img
              src="/images/sara.jpg"
              alt="Sara, your death doula, laughing"
              loading="lazy"
              className="w-full md:h-[560px] object-cover transition-transform duration-1000 ease-out hover:scale-105"
              data-testid="about-portrait"
            />
          </div>
        </Reveal>
        <div className="md:col-span-7">
          <Reveal>
            <p className="text-xs tracking-[0.35em] uppercase text-[#7D1B56] mb-8">
              Your Death Doula
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight text-[#02515A]">
              Legacy and love,
              <br />
              <span className="italic">not logistics.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-10 font-serif-display italic font-light text-2xl md:text-3xl text-[#7D1B56]">
              Hi, I'm Sara.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-6 text-base md:text-lg font-light leading-loose text-[#3F6B72] max-w-xl">
              I don't do end-of-life logistics. I do legacy and love. My role
              here is simple: to be with you as we co-create a goodbye that is
              all yours.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-6 text-base md:text-lg font-light leading-loose text-[#3F6B72] max-w-xl">
              Together, we create a moment that says: I am here. I am loved. I
              matter. And long after, this moment lives on — in stories told, in
              memories shared, in the quiet knowing that love was lived, right
              to the end.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
